import {ForYouBudgetFieldsNames} from "./for_you_budget_fields_names";

export const RegionFieldsNames = ["region"];
export const CriteriaFieldsNames = ["area", "rooms", ForYouBudgetFieldsNames.TOTAL, ForYouBudgetFieldsNames.CREDIT, ForYouBudgetFieldsNames.RADIO];
export const UserFieldsNames = ["name", "email", "phone", "marketing_consent"];
export const AdditionalCriteriaFieldsNames = ["additional_areas", "kitchen", "floor", "date", "quarters"];
import {ForYouBudgetFieldsNames} from "./for_you_budget_fields_names";

export const RegionFieldsNames = ["region"];
export const CriteriaFieldsNames = ["area", "rooms", ForYouBudgetFieldsNames.TOTAL, ForYouBudgetFieldsNames.CREDIT, ForYouBudgetFieldsNames.RADIO];
export const UserFieldsNames = ["name", "email", "phone", "marketing_consent"];
export const AdditionalCriteriaFieldsNames = ["additional_areas", "kitchen", "floor", "date", "quarters"];
